export const API_URLS = {
  ADDRESSES: '/addresses',
};
export const FEATURE_FLAGS_API_SECURITY_ENABLED =
  process.env.REACT_APP_FEATURE_FLAGS_API_SECURITY_ENABLED === 'true';
